<template>
    <div>
        <table class="table table-striped table-hover table-sticky-header custom-table">
            <thead>
            <tr>
                <th style="width: 30px;">
                    <input type="checkbox" v-model="select_all" @change="toogleSelection"></input>
                </th>
                <th v-for="col in columns" @click="sortBy(col.sort_by)" style="cursor: pointer"
                    :style="{ 'text-align': isRightAligned(col.type) ? 'right' : 'left' }"
                >
                    {{ col.name }}
                    <i v-if="col.id !== sort_by" class="fa fa-sort" style="color: grey"></i>
                    <i v-if="col.id === sort_by && sort_direction === 'asc'" class="fa fa-sort-up"></i>
                    <i v-if="col.id === sort_by && sort_direction === 'desc'" class="fa fa-sort-down"></i>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in validRows">
                <td><input type="checkbox" v-model="row.checked" @change="select"></input></td>
                <table-cell :row="row" :column="col" v-for="col in columns" :dropdowns="dropdowns" :key="row.id+';'+col.id" @openEmployerNotes="(employerId) => openEmployerNotes(employerId)"></table-cell>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <th></th>
                <th v-for="col in columns" :style="{ 'text-align': isRightAligned(col.type) ? 'right' : 'left' }">
                    <template v-if="col.type == 'money'">{{ money(sum[col.id]) }}</template>
                    <template v-else-if="col.type == 'percentage'">{{ percent(sum[col.id]) }}</template>
                    <template v-else>{{ usNum(sum[col.id]) }}</template>

                    <span v-if="sum[col.id]">
                        <span v-if="col.sum == 'sum'">Total</span>
                        <span v-if="col.sum == 'unique'">Unique</span>
                        <span v-if="col.sum == 'count'">Records</span>
                        <span v-if="col.sum == 'bool'">Enabled</span>
                    </span>
                </th>
            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import TableCell from "./parts/table-cell";

export default {
    components: {TableCell},
    props: [
        'sort_by',
        'sort_direction',
        'rows',
        'sum',
        'columns',
        'dropdowns'
    ],
    data() {
        return {
            select_all: false
        };
    },
    computed: {
        validRows() {
            return (this.rows || []).filter(row => row != null);
        }
    },
    methods: {
        isRightAligned(colType) {
            let rightAlignedTypes = [
                'money', 'percentage', 'right', 'number',
                'change', 'changePercentage', 'changeMoney',
                'pacing', 'appsvgoal', 'fulfillment'
            ]

            return rightAlignedTypes.includes(colType);
        },
        sortBy(sort_by) {
            let newSortDirection = 'desc';

            if (this.sort_by === sort_by) {
                if (this.sort_direction === 'asc') {
                    newSortDirection = 'desc';
                }
                else {
                    newSortDirection = 'asc';
                }
            }
            else {
                newSortDirection = 'asc';
            }
            return this.$emit('sorted', { sort_by: sort_by, sort_direction: newSortDirection });
        },
        toogleSelection() {
            _.each(this.rows, (r) => { r.checked = this.select_all; } );
            this.select();
        },
        select() {
            let selected = _.map(_.filter(this.rows, (r) => r.checked), (r) => r.id);
            this.$emit('select', selected);
            this.select_all = selected.length == this.rows.length;
        },
        openEmployerNotes(employerId) {
            this.$emit('openEmployerNotes', employerId);
        }
    }
}
</script>

<style>

.alr {
    text-align: right;
}

.table-sticky-header {
    position: relative;
    border-collapse: collapse;
    background: #fff;
}

.table-sticky-header thead th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
    background: #F4F6F6;
    box-shadow: inset 0 -2px 0 #ddd;
    border-bottom-width: 0 !important;
}

.table-sticky-header tfoot th {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: #F4F6F6;

    box-shadow: inset 0 2px 0 #ddd;
}

.custom-table .rbadge {
    width: 15px;
    height: 15px;
    margin-left: 5px;
    display: inline-block;
    border-radius: 50%;
}

.custom-table .sqbadge {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin-left: 5px;
}
.custom-table .pcwrapper {
    width: 60px;
    display: inline-block;
    text-align: left;
}

.custom-table .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.custom-table .flex-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-content: stretch;
}

.custom-table .icon-right {
    float: right;
    margin-left: 8px; 
    cursor: pointer;
}

.el-popover, .el-popover__title {
    word-break: normal;
    text-align: left;
}
</style>
